import React from "react"
import ReactMarkdown from "react-markdown"
import remarkGfm from "remark-gfm"
import { Button } from "antd"
import { Text, Title } from "ui/Typography"
import styles from "./ChatBox.module.css"

export function renderAIMessage(message, onOptionClick, isLatest = false) {
  const { content: rawContent = "", options = [], id: msgId, optionSelected = false } = message ?? {}
  const normalized = rawContent.replaceAll(String.raw`\n`, "\n")

  // Strip out numbered option lines and options header so we can render them as buttons
  const optionLines = []
  const mdLines = []
  let inOptionsBlock = false

  normalized.split("\n").forEach((line) => {
    const trimmed = line.trim()
    if (/^(\*{1,2})?(options|choose one|select one|choose|please select)(\*{1,2})?:?$/i.test(trimmed)) {
      inOptionsBlock = true
      return
    }
    const numberedMatch = trimmed.match(/^\d+[.)]\s+(.+)/)
    if (inOptionsBlock && numberedMatch) {
      optionLines.push(numberedMatch[1])
      return
    }
    if (inOptionsBlock && trimmed !== "" && !numberedMatch) {
      inOptionsBlock = false
    }
    mdLines.push(line)
  })

  const markdownContent = mdLines.join("\n").replaceAll(/^•\s*/gm, "- ")

  const allOptions = [...optionLines, ...(Array.isArray(options) ? options : [])]
  const selectedOption = optionSelected || null
  // Options are only interactive on the latest AI message; all previous ones are disabled
  const optionsDisabled = !isLatest || !!selectedOption

  return (
    <>
      <ReactMarkdown
        className={styles.markdownBody}
        remarkPlugins={[remarkGfm]}
        components={{
          p: ({ children }) => <Text className={styles.mdParagraph}>{children}</Text>,
          h2: ({ children }) => (
            <Title level={5} className={styles.mdHeading2}>
              {children}
            </Title>
          ),
          h3: ({ children }) => (
            <Title level={5} className={styles.mdHeading3}>
              {children}
            </Title>
          ),
          ul: ({ children }) => <ul className={styles.mdList}>{children}</ul>,
          li: ({ children }) => <li className={styles.mdListItem}>{children}</li>,
          strong: ({ children }) => <Text fw="600">{children}</Text>,
        }}
      >
        {markdownContent}
      </ReactMarkdown>
      {allOptions.length > 0 && renderOptionButtons(allOptions, msgId, "opts", onOptionClick, selectedOption, optionsDisabled)}
    </>
  )
}

function renderOptionButtons(opts, msgId, key, onOptionClick, selectedOption, isDisabled) {
  return (
    <div key={`${msgId}-${key}`} className={styles.optionButtons}>
      {opts.map((opt, i) => {
        const isSelected = opt === selectedOption
        return (
          <Button
            key={`${msgId}-${key}-${i}`}
            color="primary"
            variant="outlined"
            disabled={isDisabled}
            className={isSelected ? styles.optionButtonSelected : undefined}
            onClick={() => onOptionClick?.(opt)}
            style={{ opacity: isDisabled && !isSelected ? 0.45 : 1 }}
          >
            {opt}
          </Button>
        )
      })}
    </div>
  )
}
